import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DashboardAppShell from '../components/DashboardAppShell';
import { COMMUNITIES } from '../data';

export default function Room() {
  const { roomId } = useParams();
  const navigate = useNavigate();
  const room = COMMUNITIES.find((c) => c.id === roomId);

  const fontFamily = "'Plus Jakarta Sans', sans-serif";

  if (!room) {
    return (
      <DashboardAppShell fontFamily={fontFamily}>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 24, color: 'var(--text)' }}>Room not found</h1>
        <button type="button" onClick={() => navigate('/community')} style={{ marginTop: 16, padding: '10px 20px', background: 'var(--pink)', color: 'white', border: 'none', borderRadius: 999, cursor: 'pointer' }}>Back to Community</button>
      </DashboardAppShell>
    );
  }

  return (
    <DashboardAppShell fontFamily={fontFamily}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24 }}>
          <div style={{ width: 48, height: 48, borderRadius: 12, background: room.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24 }}>{room.icon}</div>
          <div>
            <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 24, color: 'var(--text)' }}>{room.name}</h1>
            <div style={{ fontSize: 13, color: 'var(--muted)' }}>{room.members} members · {room.desc}</div>
          </div>
        </div>
        <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 12, padding: 24, color: 'var(--muted)' }}>
          Room threads and messages — coming soon.
        </div>
    </DashboardAppShell>
  );
}
